// extracted by mini-css-extract-plugin
export default {"callout":"InfoCallout_callout__jiO9H"};